import OurGame from './OurGame';

export default OurGame;
